
import { fireUpload } from './photo-upload-fire'

export const uploadPhoto = (canvasBlobData) => {

  return fireUpload({
    fileData: canvasBlobData,
    fileName: `ImgAt${new Date().getTime()}`
  })
    .then((fireUploadResponse) => {
      console.log('fireUploadResponse', fireUploadResponse)
      return fireUploadResponse
    })
}

export const snapVideoData = (videoElementData) => {

  var {videoElement, rect: {height, width}} = videoElementData;

  return new Promise((resolve, reject) => {

    var canvas = document.createElement("canvas");
    var context = canvas.getContext('2d');
    canvas.height = height;
    canvas.width = width;
    context.drawImage(videoElement, 0, 0, width, height);
    var canvasBlobData = canvas.toBlob((toBlobResult) => {

      console.log('toBlobResult', toBlobResult)

      return resolve({
        toBlobResult,
        canvas
      })

    })



  })



}


// WEBPACK FOOTER //
// ./src/Components/JitsuCamponent/picture-messaging.js